// 導航欄翻譯

export const navbar = {
    home: 'Home',
    aiWorkbench: 'Ai Workbench',
    mvGeneration: 'Music Generation',
    myCreations: 'My Creations',
    pricing: 'Pricing',
    showcase: 'Showcase',
    profile: 'Profile',
    logout: 'Logout',
    signIn: 'Sign In'
  };
